<template>
  <div class="container is-fluid">
    <button class="button">{{ athletes.length }} athletes</button>
    
    <div class="field is-pulled-right" v-if="!$auth.loading && $auth.isAuthenticated && ($auth.user.roles.includes('director') || $auth.user.roles.includes('admin'))">
       <div class="select ">
            
            <select  v-model="roundId"  >
                <option value="0">Minimum Funding Round ...</option>
                <option v-for="row in rounds" :key="row.id" :value="row.id">{{ row.name }}</option>
            </select>
            
            
        </div>
       
       
    </div>

    
    
    <table class="table is-hoverable is-fullwidth is-size-7 " id="AthleteContactDetails">
    	<thead>
    		<th>Name</th>
            
            <th>App. Date</th>
        <th>Governing Body</th>
        <th>Employment</th>
        <th>Education</th>
        <th>School Name</th>
          <th >DOB</th>
          <th >Age</th>
          <th>Gender</th>
          <th >Round</th>
          <th >Status</th>
          
          
    	</thead>

        <tbody>
            <tr v-for="row in athletes" :key="row.id">
                <td>{{ row.forename }} {{ row.surname }}</td>
               
                <td>{{ row.date }}</td>
                <td>{{ row.governing_body_name }}</td>
                <td>{{ row.employment }}</td>
                <td>{{ row.education }}</td>
                <td>{{ row.school_name }}</td>
                <td>{{ row.dob  }}</td>
                <td>{{  row.age  }}</td>
                <td>{{ row.gender }}</td>
                <td>{{ row.round_name }}</td>
                <td>
                    <span v-if="row.awarded == 1">Awarded</span>
                    <span v-if="row.awarded == 2 && row.endorsed == 1">Not Awarded</span>
                    <span v-if="row.awarded == 0 && row.endorsed == 2">Not Endorsed</span>
                    <span v-if="row.awarded == 0 && row.endorsed == 1">Endorsed</span>

                </td>
            </tr>

        </tbody>
    	
		    
    
    </table>
    
    <div class="buttons">
    <button class="button is-success" @click="exportXLS()">Export Results to Excel</button>
    </div>
    

  </div>
</template>

<script>


import ApplicationService from '@/services/ApplicationService.js';
import XLSX from 'xlsx';

export default {
  components: {
   	
  },
  data() {
    return {
      orders: [],
      errors: [],
      athletes: [],
      governing_bodies:[],
      council_areas:[],
      rounds: [],
      orderBy:"",
      governingBodyId: 0,
      councilAreaId: 0,
      roundId:process.env.VUE_APP_CURRENT_ROUND_ID,
    }
  },
  
  // Fetches posts when the component is created.
  created() {
    this.getAccessToken()
    .then(() => { 
        
     
       this.getRounds();
       this.getAthletes();
    });
  },
  watch: {
    '$route'() {
     this.getAthletes();
    
    },
    
    roundId: function() {
      this.getAthletes();
     
    }
  },
  methods: {
  	async getAccessToken() {
      this.accessToken = await this.$auth.getTokenSilently()
    },
    async getGoverningBodies() {
        
      ApplicationService.getGoverningBodies("")
      .then(
        (governing_bodies => {
          this.$set(this, "governing_bodies", governing_bodies);
        }).bind(this)
      );
    },
    
    async getRounds() {
       
      ApplicationService.getRounds(this.accessToken)
      .then(
        (rounds => {
          this.$set(this, "rounds", rounds);
        }).bind(this)
      );
    },
    async getAthletes() {
     
      // Use the eventService to call the getEventSingle() method
      ApplicationService.getAthletesBreakdown(this.accessToken, this.roundId)
      .then(
        (athletes => {
          this.$set(this, "athletes", athletes);
        }).bind(this)
      );
    },
    
     exportXLS() {
        //alert("hi")
        var wb = XLSX.utils.table_to_book(document.getElementById('AthleteContactDetails'), {sheet:"Sheet JS"});
        XLSX.writeFile(wb, 'athlete-contact-details.xlsx')

    },
    
    
  }
}


</script>

<style>
	
</style>
